<template>
  <v-main>
    <title-component :img="img" :title="title"/>
    <v-container class="mx-auto" style="max-width: 1100px;">
      <div class="text-body-1">社内規程は下記フォルダに格納しております。
        <br>
        <span class="font-weight-bold">\\Gaia\全社共有\規程</span>
      </div>
    </v-container>
  </v-main>
</template>
<script>
import Title from '@/components/Title';

export default {
  name: 'RegulationView',
  components: {
    'title-component': Title,
  },
  data() {
    return {
      title: '規程',
      img: 'title_regulation.svg',
    };
  },
};
</script>

<style scoped>

</style>